import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_STATS = "GET_STATS";

export function getStatsAction(stats) {
  return { type: GET_STATS, stats: stats };
}

const getExport = (APIUrl, successCallback) => {
  return function (dispatch) {
    return axios
      .get(APIUrl, { responseType: "arraybuffer" })
      .then(function (response) {
        if (response) {
          return successCallback(response);
        }
      })
      .catch(function (err) {
        console.log(err);
        throw err;
      });
  };
};

export const getE4collEstablishmentsByCompany = function (companyId, successCallback) {
  return getExport(APIUrl.getE4collEstablishmentsByCompany + companyId, successCallback);
};

export const getE4collEstablishmentsUsersByCompany = function (
  companyId, successCallback,
) {
  return getExport(
    APIUrl.getE4collEstablishmentsUsersByCompany + companyId,
    successCallback,
  );
};

export const getE4collDmByCompany = function (companyId, successCallback) {
  return getExport(APIUrl.getE4collDmByCompany + companyId, successCallback);
};

export const getE4collInterventionsByCompany = function (companyId, successCallback) {
  return getExport(
    APIUrl.getE4collInterventionsByCompany + companyId,
    successCallback,
  );
};

export const getE4collMaintenancesByCompany = function (companyId, successCallback) {
  return getExport(
    APIUrl.getE4collMaintenancesByCompany + companyId,
    successCallback,
  );
};
